import React, { ReactElement, useEffect } from 'react';
import { useQuery } from '../../../../services/routers/router';
import {
  AuthState,
  everyHashCode,
  lineHashCode,
  useAuth,
} from '../../../auth/AuthProvider';

export const CallbackCode = (): ReactElement => {
  const query = useQuery();
  const { loginFirebaseWithEveryIdCode, loginFirebaseWithLINECode } =
    useAuth() as AuthState;

  useEffect(() => {
    const code = query.get('code');
    const state = query.get('state');

    if (!code) {
      return;
    }

    if (state != undefined && state.indexOf(`${lineHashCode}`) > -1) {
      loginFirebaseWithLINECode(code);
    } else if (state != undefined && state.indexOf(`${everyHashCode}`) > -1) {
      loginFirebaseWithEveryIdCode(code);
    }
  }, []);

  return <>ログインしています...</>;
};
